const Customer = () => {
   return (
      <svg width="22" height="22" fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.9" d="M11 20.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19z">
         </path>
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.9" d="M4.5 17.5c0-1.657 2.646-3 5.91-3h1.18c3.264 0 5.91 1.343 5.91 3M11 11.5a3 3 0 100-6 3 3 0 000 6z">
         </path>
      </svg>
   )
}

export default Customer;